module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"uploadFile":"JSON-Datei auswählen","pendingMessage":"Liegenschaft wird importiert, dieser Vorgang kann einen Moment dauern.","submitImport":"Bestätigen"}}')
  delete Component.options._Ctor
}
